<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="firstInSection"><em>‘Cut-throat Defence’</em><br/>
– A defendant implicates a co-accused in the commission of the offence.</p>
<p><em>‘To see what is right, and not to do it, is want of courage.’</em><br/>
Confucius, 551‒479 BC</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?4d226e56